import React from 'react';

const EditPage = React.lazy(() => import('./EditPage'));
const CreatePage = React.lazy(() => import('./CreatePage'));
const ConfigurePages = React.lazy(() => import('./ConfigurePages'));

export { EditPage, CreatePage, ConfigurePages };
